var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEcrireRemarque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AECB",
    d: "M.151 16.099c-.102.612.52 1.09 1.08.828l3.89-1.817c.864.318 1.784.484 2.726.484h6.306c4.331 0 7.847-3.483 7.847-7.786v-.022C22 3.482 18.485 0 14.153 0H7.847C3.516 0 0 3.483 0 7.786v.022c0 1.286.32 2.53.92 3.648L.152 16.1zm2.328-4.657c.03-.18-.004-.363-.095-.52-.554-.946-.85-2.01-.85-3.114v-.022c0-3.444 2.824-6.24 6.313-6.24h6.306c3.49 0 6.312 2.796 6.312 6.24v.022c0 3.443-2.823 6.24-6.312 6.24H7.847c-.856 0-1.687-.168-2.457-.49-.199-.084-.423-.08-.618.012l-2.868 1.339.575-3.467z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEcrireRemarque);
export default __webpack_public_path__ + "static/media/icon-ecrire-remarque.df28dbd759f2232586629f956368c8cf.svg";
export { ForwardRef as ReactComponent };